export default __webpack_public_path__ + "static/media/blog7.e0da8214.png";